import { useMutation } from "react-query";
import { addScorecard } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useAddScoreCard = () => {
    return useMutation(addScorecard);
};
export default useAddScoreCard;